module.exports = __webpack_public_path__ + "static/img/db1.92cba4ed.jpg";